import { Reveal } from '../Reveal';
import { CheckList, Chip, DemoCaption, PhoneFrame } from './shared';

// Section 5 — Business Health. Two-column navy feature; demo score is never
// presented as a genuine result.
export const CompassHealth = ({ sp }) => (
  <section aria-labelledby="compass-health-heading" data-testid="compass-health" className="relative overflow-hidden bg-navy-900 py-20 sm:py-28">
    <div className="grain-overlay" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold-500">Business Health</p>
        <h2 id="compass-health-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="compass-health-heading">
          Understand where the business needs attention
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-300">{sp.healthCopy}</p>
        <div className="mt-6 flex flex-wrap gap-2" aria-label="Business health areas">
          {(sp.healthAreas || []).map((area) => (
            <Chip key={area} dark>{area}</Chip>
          ))}
        </div>
        <div className="mt-8">
          <CheckList items={sp.healthPoints || []} dark testid="compass-health-points" />
        </div>
        <p className="mt-6 border-l-2 border-gold-500 pl-4 text-sm font-medium leading-relaxed text-slate-300">
          The value is the interpretation and the follow-through — not the score alone.
        </p>
      </Reveal>
      <Reveal delay={0.12}>
        <PhoneFrame shot={sp.shots.healthMobile} className="mx-auto max-w-[300px]" />
        <DemoCaption className="text-slate-500" />
      </Reveal>
    </div>
  </section>
);
